// extracted by mini-css-extract-plugin
module.exports = {"Button":"SettingsUserData_Button__F4R9P","Title":"SettingsUserData_Title__wuX_Y","Text":"SettingsUserData_Text__maeCq"};